import { createReduxAsyncAction } from '../utils/toolkit';
import { TYPES } from './constants';

export const loadVehicles = createReduxAsyncAction(TYPES.LOAD_VEHICLES);
export const loadAvailableVehicles = createReduxAsyncAction(TYPES.LOAD_AVAILABLE_VEHICLES);
export const loadFilteredVehicles = createReduxAsyncAction(TYPES.LOAD_FILTERED_VEHICLES);
